// css
import '../../scss/pages/page-about.scss';
import { gsap } from 'gsap';

// utils
import foundation from '../_utils/foundation';
import { Modal } from '../_libs/modal-menu';
// import imageMapResize from 'image-map-resizer';

function initMapIconFloat() {
	const mapIcons = document.querySelectorAll('.js-map-icon');
	if (mapIcons.length === 0) return;

	const prefersReducedMotion = window.matchMedia(
		'(prefers-reduced-motion: reduce)'
	).matches;
	if (prefersReducedMotion) {
		gsap.set(mapIcons, { clearProps: 'transform' });
		return;
	}

	mapIcons.forEach((icon) => {
		gsap.set(icon, { y: -12 });

		const tl = gsap.timeline({
			repeat: -1,
			delay: -Math.random(),
		});

		// 下方向へバウンドしながら落下
		tl.to(icon, {
			y: 0,
			duration: 1.2,
			ease: 'elastic.out(1,0.4)',
		});

		// 初期位置（setのy:-12）まで上方向へ戻る
		tl.to(icon, {
			y: -12,
			duration: 1,
			ease: 'power3.out',
		});
	});
}

function initAboutModal() {
	const modalElement = document.querySelector('.js-aboutMenu');
	if (!modalElement) return;

	const aboutModalData = /** @type {any} */ (window).KawasakiAboutModalData;
	if (!aboutModalData || typeof aboutModalData !== 'object') return;

	const templateDir =
		typeof aboutModalData.templateDir === 'string'
			? aboutModalData.templateDir
			: '';
	const items = Array.isArray(aboutModalData.items)
		? aboutModalData.items
		: [];

	if (!Array.isArray(items) || items.length === 0) return;
	if (!templateDir) return;

	items.sort((a, b) => Number(a.button_link) - Number(b.button_link));

	const aboutMenuModal = new Modal({
		modal: '.js-aboutMenu',
		htmlClassName: 'is-about-menu-open',
		modalFocusArea: '.js-aboutMenu-button[button-link]',
		inertArea: '.lContainer',
		overlay: '.js-aboutMenu-overlay',
	});

	aboutMenuModal.init();

	const openButtons = document.querySelectorAll(
		'.js-aboutMenu-button[button-link]'
	);
	const closeButton = modalElement.querySelector('.js-aboutMenu-close');
	const prevButton = modalElement.querySelector('.js-aboutMenu-prev');
	const nextButton = modalElement.querySelector('.js-aboutMenu-next');

	const titleEn = modalElement.querySelector('.js-aboutMenu-title-en');
	const titleJa = modalElement.querySelector('.js-aboutMenu-title-ja');
	const text = modalElement.querySelector('.js-aboutMenu-text');
	const imageWebp = modalElement.querySelector('.js-aboutMenu-image-webp');
	const image = modalElement.querySelector('.js-aboutMenu-image');
	const relatedList = modalElement.querySelector(
		'.js-aboutMenu-related-list'
	);

	if (
		!closeButton ||
		!prevButton ||
		!nextButton ||
		!titleEn ||
		!titleJa ||
		!text ||
		!imageWebp ||
		!image ||
		!relatedList
	) {
		return;
	}

	let currentIndex = 0;

	const getImagePath = (imageName, suffix, ext) => {
		return `${templateDir}/assets/image/about${suffix}/${imageName}${ext}`;
	};

	const updateImage = (imageName) => {
		imageWebp.setAttribute(
			'srcset',
			getImagePath(imageName, '/webp', '-pc.webp')
		);
		image.setAttribute('srcset', getImagePath(imageName, '', '-pc.png'));
		imageWebp.setAttribute(
			'srcset',
			getImagePath(imageName, '/webp', '.webp')
		);
		image.setAttribute('src', getImagePath(imageName, '', '.png'));
	};

	const escapeText = (value) => {
		const map = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			'"': '&quot;',
			"'": '&#039;',
		};

		return String(value || '').replace(/[&<>"']/g, (char) => map[char]);
	};

	const setRelatedItems = (posts) => {
		if (!posts || posts.length === 0) {
			relatedList.innerHTML =
				'<p class="cAboutModal__related_empty">該当する関連企業はありません。</p>';
			return;
		}

		relatedList.innerHTML = posts
			.map((post) => {
				const title = post?.title?.rendered || '';
				const link = post?.link || '#';
				const image = post?.acf?.thum_image?.sp || '';
				const companyText = post?.acf?.company_text || '';
				return `
					<article class="cAboutModal__related_item">
						<a href="${link}" class="cAboutModal__related_link" target="_self" rel="noopener noreferrer">
							<div class="cAboutModal__related_link_image">
								<img src="${image}" width="150" height="100" alt="" decoding="auto" loading="lazy" />
							</div>
							<div class="cAboutModal__related_link_info">
								<h3 class="cAboutModal__related_link_info_name">${title}</h3>
								<p class="cAboutModal__related_link_info_text">${companyText || escapeText('')}</p>
							</div>
						</a>
					</article>
				`;
			})
			.join('');
	};

	const fetchRelatedItems = async (businessFieldIds) => {
		const ids = Array.isArray(businessFieldIds)
			? businessFieldIds.map((id) => Number(id)).filter((id) => id > 0)
			: [Number(businessFieldIds)].filter((id) => id > 0);

		if (ids.length === 0) {
			setRelatedItems([]);
			return;
		}

		try {
			const responses = await Promise.all(
				ids.map((id) =>
					fetch(
						`/wp-json/wp/v2/posts?business_field=${id}&order=asc&per_page=100`
					)
				)
			);

			responses.forEach((response) => {
				if (!response.ok) {
					throw new Error(`HTTP ${response.status}`);
				}
			});

			const postsByField = await Promise.all(
				responses.map((response) => response.json())
			);
			const allPosts = postsByField.flat();
			const uniquePosts = Array.from(
				new Map(allPosts.map((post) => [post?.id, post])).values()
			);

			setRelatedItems(uniquePosts);
		} catch (error) {
			console.error('Failed to fetch related companies:', error);
			setRelatedItems([]);
		}
	};

	const updateModal = async () => {
		const item = items[currentIndex];
		if (!item) return;

		titleEn.textContent = item.title_en || 'khi Group business';
		titleJa.textContent = item.title_ja || '';
		text.textContent = item.text || '';
		updateImage(item.image_name || 'about-menu-image1');

		await fetchRelatedItems(
			item.business_field_ids || item.business_field_id || []
		);
	};

	const openModalByButton = async (buttonLink) => {
		const index = items.findIndex(
			(item) => String(item.button_link) === String(buttonLink)
		);
		if (index === -1) return;

		currentIndex = index;
		await updateModal();
		aboutMenuModal.openModal();
	};

	openButtons.forEach((button) => {
		button.addEventListener('click', async () => {
			await openModalByButton(button.getAttribute('button-link'));
		});
	});

	closeButton.addEventListener('click', () => {
		aboutMenuModal.closeModal();
	});

	closeButton.addEventListener('keydown', (event) => {
		const keyboardEvent = /** @type {KeyboardEvent} */ (event);
		if (keyboardEvent.key === 'Enter' || keyboardEvent.key === ' ') {
			event.preventDefault();
			aboutMenuModal.closeModal();
		}
	});

	prevButton.addEventListener('click', async () => {
		currentIndex = (currentIndex - 1 + items.length) % items.length;
		await updateModal();
	});

	nextButton.addEventListener('click', async () => {
		currentIndex = (currentIndex + 1) % items.length;
		await updateModal();
	});
}

document.addEventListener('DOMContentLoaded', () => {
	foundation();
	initMapIconFloat();
	initAboutModal();
	// imageMapResize();
});

window.addEventListener('load', () => {});
